import { useBahasa } from '../../../app/i18n'
import { useFiturTenant } from '../../../domains/tenancy/api'
import { Baris, Bendera, Chip, Gagal, Memuat, Panel, Tabel } from '../../../shared/ui'

/**
 * FITUR — DIBACA SAJA oleh admin tenant, dan itu keputusan 11 September 2026.
 *
 * Fitur adalah yang Seleris JUAL. Sampai hari ini tombol Nyalakan/Matikan ada DI SINI,
 * sementara konsol operator tidak punya satu pun — jadi klien bisa mengambil apa saja
 * dari katalog sendiri, dan yang menjualnya harus memakai curl. Arahnya terbalik.
 *
 * Yang TIDAK dicabut: hak melihat. Klien yang bertanya "kenapa scraping saya tidak jalan"
 * berhak menemukan jawabannya sendiri — dan "fiturnya memang mati" adalah jawaban yang
 * paling sering benar. Layar tanpa daftar ini akan memindahkan pertanyaan itu ke kita.
 *
 * Setelan per fitur TETAP milik klien: topik scraping, field profiling, jadwal meeting.
 * ADR-023 menempelkannya pada fiturnya, dan backend memisahkan wewenangnya per FIELD —
 * `enabled` menuntut `smova_admin`, `settings` tidak.
 */
export default function Fitur() {
  const { t } = useBahasa()
  const q = useFiturTenant()

  return (
    <>

      <Panel judul={t('ta.fiturJudul')} catatan={t('ta.fiturCatatan')}>
        {q.isLoading && <Memuat tinggi={6} />}
        {q.isError && <Gagal galat={q.error} ulangi={q.refetch} />}

        {q.data && (
          <Tabel kepala={[t('ta.kolFitur'), t('ta.kolButuh'), t('ta.kolKeadaan')]}>
            {q.data.map((f) => (
                <Baris key={f.key}>
                  <td>
                    <b className="block text-[13px] font-semibold">{f.name}</b>
                    <span className="font-mono text-[11px] text-ink3">{f.key}</span>
                  </td>
                  <td>
                    <span className="flex flex-wrap gap-1">
                      {f.butuh.length === 0 && <span className="text-ink3">—</span>}
                      {f.butuh.map((b) => (
                        <span key={b} className="font-mono text-[11px] bg-surface2
                                                 border border-line rounded px-1.5 py-0.5">
                          {b}
                        </span>
                      ))}
                    </span>
                  </td>
                  <td>
                    <Chip nada={f.enabled ? 'ok' : 'idle'}>
                      {f.enabled ? t('ta.hidup') : t('ta.mati')}
                    </Chip>
                  </td>
                </Baris>
            ))}
          </Tabel>
        )}
      </Panel>

      <Bendera nada="info" judul={t('ta.fiturSiapaJudul')} className="max-w-[80ch]">
        {t('ta.fiturSiapaIsi')}
      </Bendera>
    </>
  )
}
